// extracted by mini-css-extract-plugin
module.exports = {"displayName":"style__displayName__BiV7a"};